enum Steps {
  All = 'all',
  Instructions = 1,
  PersonalData,
  Questionnaire,
  Documents,
  Complete,
}

export default Steps;
